import { makeStyles } from '@fluentui/react-components';
import { FC } from 'react';
import { PersonaList } from './PersonaList';
import { PersonaWindow } from './PersonaWindow';

const useClasses = makeStyles({
    container: {
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'start',
        height: '100%',
    },
});

export const PersonaView: FC = () => {
    const classes = useClasses();

    return (
        <div className={classes.container}>
            <PersonaList />
            <PersonaWindow />
        </div>
    );
};
